import { SUCCESS_CODE } from '@/constants'
import { MockMethod } from 'vite-plugin-mock'

const commentList: any[] = [
  {
    id: 1,
    commodity_id: 'C1001',
    order_id: 'O2001',
    settlement_amount: 250.0,
    buyer_name: '张三',
    commend_score: 5,
    commend_content: '非常满意，质量很好！',
    commend_time: '2025-05-01 10:00:00',
    status: 'ok'
  },
  {
    id: 2,
    commodity_id: 'C1002',
    order_id: 'O2002',
    settlement_amount: 99.9,
    buyer_name: '李四',
    commend_score: 4,
    commend_content: '价格实惠，值得购买。',
    commend_time: '2025-05-02 11:20:00',
    status: 'ok'
  },
  {
    id: 3,
    commodity_id: 'C1003',
    order_id: 'O2003',
    settlement_amount: 150.0,
    buyer_name: '王五',
    commend_score: 3,
    commend_content: '一般般，发货慢。',
    commend_time: '2025-05-03 09:45:00',
    status: 'ok'
  },
  {
    id: 4,
    commodity_id: 'C1004',
    order_id: 'O2004',
    settlement_amount: 500.0,
    buyer_name: '赵六',
    commend_score: 2,
    commend_content: '体验不好，不推荐。',
    commend_time: '2025-05-04 14:10:00',
    status: 'delete'
  },
  {
    id: 5,
    commodity_id: 'C1005',
    order_id: 'O2005',
    settlement_amount: 75.5,
    buyer_name: '钱七',
    commend_score: 5,
    commend_content: '物美价廉，快递给力！',
    commend_time: '2025-05-05 08:00:00',
    status: 'ok'
  },
  {
    id: 6,
    commodity_id: 'C1006',
    order_id: 'O2006',
    settlement_amount: 199.0,
    buyer_name: '孙八',
    commend_score: 4,
    commend_content: '性价比高，满意。',
    commend_time: '2025-05-06 12:30:00',
    status: 'ok'
  },
  {
    id: 7,
    commodity_id: 'C1007',
    order_id: 'O2007',
    settlement_amount: 450.0,
    buyer_name: '周九',
    commend_score: 3,
    commend_content: '还可以，有待提升。',
    commend_time: '2025-05-07 15:45:00',
    status: 'ok'
  },
  {
    id: 8,
    commodity_id: 'C1008',
    order_id: 'O2008',
    settlement_amount: 320.75,
    buyer_name: '吴十',
    commend_score: 5,
    commend_content: '超级赞！物超所值。',
    commend_time: '2025-05-08 09:15:00',
    status: 'ok'
  },
  {
    id: 9,
    commodity_id: 'C1009',
    order_id: 'O2009',
    settlement_amount: 50.0,
    buyer_name: '郑十一',
    commend_score: 1,
    commend_content: '差评，服务差！',
    commend_time: '2025-05-09 17:40:00',
    status: 'delete'
  },
  {
    id: 10,
    commodity_id: 'C1010',
    order_id: 'O2010',
    settlement_amount: 130.25,
    buyer_name: '冯十二',
    commend_score: 4,
    commend_content: '不错，推荐。',
    commend_time: '2025-05-10 13:25:00',
    status: 'ok'
  },
  {
    id: 11,
    commodity_id: 'C1011',
    order_id: 'O2011',
    settlement_amount: 220.0,
    buyer_name: '陈十三',
    commend_score: 3,
    commend_content: '中规中矩。',
    commend_time: '2025-05-11 10:55:00',
    status: 'ok'
  },
  {
    id: 12,
    commodity_id: 'C1012',
    order_id: 'O2012',
    settlement_amount: 180.0,
    buyer_name: '韩十四',
    commend_score: 5,
    commend_content: '很喜欢，下次再来。',
    commend_time: '2025-05-12 11:05:00',
    status: 'ok'
  },
  {
    id: 13,
    commodity_id: 'C1013',
    order_id: 'O2013',
    settlement_amount: 80.5,
    buyer_name: '朱十五',
    commend_score: 2,
    commend_content: '包装破损，不满意。',
    commend_time: '2025-05-13 08:45:00',
    status: 'delete'
  },
  {
    id: 14,
    commodity_id: 'C1014',
    order_id: 'O2014',
    settlement_amount: 270.0,
    buyer_name: '秦十六',
    commend_score: 4,
    commend_content: '物流快，服务好。',
    commend_time: '2025-05-14 15:10:00',
    status: 'ok'
  },
  {
    id: 15,
    commodity_id: 'C1015',
    order_id: 'O2015',
    settlement_amount: 350.0,
    buyer_name: '尤十七',
    commend_score: 5,
    commend_content: '五星好评！',
    commend_time: '2025-05-15 14:20:00',
    status: 'ok'
  },
  {
    id: 16,
    commodity_id: 'C1016',
    order_id: 'O2016',
    settlement_amount: 90.0,
    buyer_name: '许十八',
    commend_score: 1,
    commend_content: '不喜欢，质量差。',
    commend_time: '2025-05-16 10:50:00',
    status: 'delete'
  },
  {
    id: 17,
    commodity_id: 'C1017',
    order_id: 'O2017',
    settlement_amount: 400.0,
    buyer_name: '何十九',
    commend_score: 3,
    commend_content: '还行吧。',
    commend_time: '2025-05-17 12:15:00',
    status: 'ok'
  },
  {
    id: 18,
    commodity_id: 'C1018',
    order_id: 'O2018',
    settlement_amount: 215.25,
    buyer_name: '吕二十',
    commend_score: 4,
    commend_content: '质量很好，物有所值。',
    commend_time: '2025-05-18 11:35:00',
    status: 'ok'
  },
  {
    id: 19,
    commodity_id: 'C1019',
    order_id: 'O2019',
    settlement_amount: 160.0,
    buyer_name: '施二一',
    commend_score: 2,
    commend_content: '一般般。',
    commend_time: '2025-05-19 09:25:00',
    status: 'ok'
  },
  {
    id: 20,
    commodity_id: 'C1020',
    order_id: 'O2020',
    settlement_amount: 300.0,
    buyer_name: '姚二二',
    commend_score: 5,
    commend_content: '棒极了！',
    commend_time: '2025-05-20 14:40:00',
    status: 'ok'
  }
]

export default [
  {
    url: '/mock/commentlist/list',
    method: 'get',
    response: ({ query }) => {
      const { pageIndex = 1, pageSize = 10, startTime, endTime, source } = query
      const filteredList = commentList

      const start = (pageIndex - 1) * pageSize
      const end = start + Number(pageSize)

      return {
        code: SUCCESS_CODE,
        data: {
          list: filteredList.slice(start, end),
          total: filteredList.length
        }
      }
    }
  }
] as MockMethod[]
